var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa-regular:file-pdf",
    clipPath: "url(#clip0_5583_5366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.63281 3.17969L7.44792 0.885547C7.21354 0.639453 6.89583 0.5 6.5651 0.5H1.25C0.559896 0.502734 0 1.09062 0 1.81523V13.1902C0 13.9148 0.559896 14.5027 1.25 14.5027H8.75C9.4401 14.5027 10 13.9148 10 13.1902V4.10938C10 3.76211 9.86719 3.42578 9.63281 3.17969ZM8.64844 4.00273H6.66667V1.92188L8.64844 4.00273ZM1.25 13.1902V1.81523H5.41667V4.65898C5.41667 5.02266 5.69531 5.31523 6.04167 5.31523H8.75V13.1902H1.25ZM7.76562 9.26094C7.44792 8.93281 6.54167 9.02305 6.08854 9.0832C5.64062 8.79609 5.34115 8.39961 5.13021 7.81719C5.23177 7.37695 5.39323 6.70703 5.27083 6.28594C5.16146 5.56953 4.28646 5.64063 4.16146 6.12461C4.04688 6.56484 4.15104 7.17734 4.34375 7.95938C4.08333 8.61289 3.69531 9.49063 3.42187 9.99375C2.90104 10.2754 2.19792 10.7102 2.09375 11.257C2.00781 11.6891 2.77083 12.7664 4.07552 10.4039C4.65885 10.2016 5.29427 9.95273 5.85677 9.8543C6.34896 10.1332 6.92448 10.3191 7.3099 10.3191C7.97396 10.3191 8.03906 9.54805 7.76562 9.26094ZM2.60677 11.3883C2.73958 11.0137 3.24479 10.5816 3.39844 10.4313C2.90365 11.2598 2.60677 11.4074 2.60677 11.3883ZM4.73177 6.17656C4.92448 6.17656 4.90625 7.0543 4.77865 7.29219C4.66406 6.91211 4.66667 6.17656 4.73177 6.17656ZM4.09635 9.91172C4.34896 9.44961 4.5651 8.9 4.73958 8.41602C4.95573 8.82891 5.23177 9.15977 5.52344 9.38672C4.98177 9.5043 4.51042 9.74492 4.09635 9.91172ZM7.52344 9.775C7.52344 9.775 7.39323 9.93906 6.55208 9.56172C7.46615 9.49062 7.61719 9.70938 7.52344 9.775Z",
    fill: "#010048"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5583_5366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.e1986ea32485a9e1392e3bfbeb18aabc.svg";
export { ForwardRef as ReactComponent };